import { Spinner } from "@pancakeswap/uikit";

export type { SpinnerProps } from "./types";
export { default as Spinner } from "./Spinner";
export { SpinnerLayout } from "./Spinner";

export default Spinner;